import React, { useEffect, useState } from "react";
import api from "../Axios/api";
import Select from "react-select";
const ComputerFormModal = ({
  isModalOpen,
  staffNameDropdown,
  facLocation,
  setIsModalOpen,
  isEditMode,
  formData,
  setFormData,
  invoice,
  assetsDropdown,
  selectedRow,
  handleDynamicChange,
  addFormDetails,
}) => {
  if (!isModalOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setIsModalOpen(false);
          setFormData([]);
        }
      }}
    >
      <div className="bg-white rounded-lg shadow-xl w-full mx-4 p-4 overflow-y-auto max-h-[90vh] min-h-[40vh]">
        <h3 className="text-xl font-bold text-gray-800 mb-6 text-center border-b-4 border-blue-500 inline-block pb-2">
          Invoice No. {invoice}
        </h3>

        <form onSubmit={addFormDetails} className="space-y-20">
          <table className="min-w-full table-auto border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="border px-4 py-2 w-[150px]">Item</th>
                <th className="border px-4 py-2 w-[100px]">Quantity</th>
                <th className="border px-4 py-2 w-[100px]">Rate</th>
                <th className="border px-4 py-2 w-[300px]">Serial Number</th>
                <th className="border px-4 py-2 w-[250px]">Item Status</th>
                <th className="border px-4 py-2 w-[120px]">User</th>
                <th className="border px-4 py-2 w-[120px]">IT Spare</th>
                <th className="border px-4 py-2 w-[180px]">Factory Name</th>
                <th className="border px-4 py-2 w-[160px]">Work Area</th>
                <th className="border px-4 py-2 w-[120px]">Warranty</th>
                <th className="border px-4 py-2 w-[160px]">Warranty Expiry</th>
                <th className="border px-4 py-2 w-[260px]">Remark</th>
              </tr>
            </thead>
            <tbody>
              {selectedRow.map((item, index) => (
                <tr key={item.receipt_item_id}>
                  <td className="border px-4 py-2">{item.receipt_item_name}</td>
                  <td className="border px-4 py-2">{item.receipt_item_qty}</td>
                  <td className="border px-4 py-2">{item.receipt_item_rate}</td>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="serialNumber"
                      value={formData[index]?.serialNumber || ""}
                      onChange={(e) => handleDynamicChange(e, index)}
                      placeholder="Serial Number"
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                    />
                  </td>
                  <td className="border px-4 py-2">
                    <select
                      name="status"
                      value={formData[index]?.status || ""}
                      onChange={(e) => handleDynamicChange(e, index)}
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                    >
                      <option value="">Select</option>
                      <option value="New">New</option>
                      <option value="Maintanance">Maintanance</option>
                    </select>
                  </td>

                  <td className="border px-4 py-2 w-[180px]">
                    <Select
                      isMulti
                      options={staffNameDropdown}
                      value={staffNameDropdown.filter((option) =>
                        formData[index].user?.includes(option.value)
                      )}
                      name="user"
                      placeholder="SELECT"
                      onChange={(selectedOptions) =>
                        handleDynamicChange(
                          {
                            target: {
                              name: "user",
                              value: selectedOptions
                                ? selectedOptions.map((opt) => opt.value)
                                : [],
                            },
                          },
                          index
                        )
                      }
                    />
                  </td>
                  
           
                      <td className="border px-4 py-2">
                    <input
                      type="number"
                      name="ITStockQty"
                      value={formData[index]?.ITStockQty || ""}
                      onChange={(e) => handleDynamicChange(e, index)}
                      placeholder="QTY"
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                    />
                  </td>
                  <td className="border px-4 py-2 w-[180px]">
                    <Select
                      isMulti
                      options={facLocation}
                      value={facLocation.filter((option) =>
                        formData[index].factory?.includes(option.value)
                      )}
                      name="factory"
                      placeholder="SELECT"
                      isClearable
                      onChange={(selectedOptions) =>
                        handleDynamicChange(
                          {
                            target: {
                              name: "factory",
                              value: selectedOptions
                                ? selectedOptions.map((opt) => opt.value)
                                : [],
                            },
                          },
                          index
                        )
                      }
                    />
                  </td>

                  <td className="border px-4 py-2 w-[180px]">
                    <Select
                      isMulti
                      options={assetsDropdown}
                      value={assetsDropdown.filter((option) =>
                        formData[index].area?.includes(option.value)
                      )}
                      name="area"
                      placeholder="SELECT"
                      isClearable
                      onChange={(selectedOptions) =>
                        handleDynamicChange(
                          {
                            target: {
                              name: "area",
                              value: selectedOptions
                                ? selectedOptions.map((opt) => opt.value)
                                : [],
                            },
                          },
                          index
                        )
                      }
                    />
                  </td>

                  <td className="border px-4 py-2">
                    <select
                      name="warranty"
                      value={formData[index]?.warranty || ""}
                      onChange={(e) => handleDynamicChange(e, index)}
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                    >
                      <option value="">Select</option>
                      <option value="No warranty">No Warranty</option>
                      <option value="6 Months">6 Months</option>
                      <option value="1 Year">1 Year</option>
                      <option value="2 Years">2 Years</option>
                      <option value="3 Years">3 Years</option>
                      <option value="4 Years">4 Years</option>
                      <option value="5 Years">5 Years</option>
                    </select>
                  </td>
                  <td className="border px-4 py-2">
                    <input
                      type="date"
                      name="warrantyExpiry"
                      value={
                        formData[index]?.warrantyExpiry?.split("T")[0] || ""
                      }
                      onChange={(e) => handleDynamicChange(e, index)}
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                    />
                  </td>

                  <td className="border px-4 py-2">
                    <textarea
                      name="remark"
                      value={formData[index]?.remark || ""}
                      onChange={(e) => handleDynamicChange(e, index)}
                      className="w-full px-2 py-1 border border-gray-300 rounded"
                      rows={3}
                      placeholder="Enter remark"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Submit / Cancel Actions */}
          <div className="flex justify-end gap-4 pt-4">
            <button
              type="button"
              onClick={() => {
                setIsModalOpen(false);
                setFormData([]);
              }}
              className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              {isEditMode ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default ComputerFormModal;
